import { formatDateForInput } from 'helpers/dateHelpers';
import { ListViewControls } from 'types/prospect';

type ListViewStageOption = {
  label: string;
  value: string;
  group?: string;
  noIndent?: boolean;
};

const LEAD_STAGE_OPTIONS = [
  { label: 'None Selected', value: 'default' },
  {
    value: 'all-leads',
    label: 'All Leads',
  },
  {
    value: '1. Acquisition',
    label: '1. Acquisition',
  },
  {
    value: '2. Traige',
    label: '2. Traige',
  },
  {
    value: '3. Contact',
    label: '3. Contact',
  },
  {
    value: '4. Inactive',
    label: '4. Inactive',
  },
  {
    value: '5. Disqualified',
    label: '5. Disqualified',
  },
  {
    value: '6. Qualified',
    label: '6. Qualified',
  },
  {
    value: '7. Converted',
    label: '7. Converted',
  },
];

const OPPORTUNITY_STAGE_OPTIONS = [
  { label: 'None Selected', value: 'default' },
  {
    value: 'all-opportunities',
    label: 'All Opportunities',
  },
  {
    value: '1. Created',
    label: '1. Created',
  },
  {
    value: '2. Appointment Scheduled',
    label: '2. Appointment Scheduled',
  },
  {
    value: '3. Initial Appointment Complete',
    label: '3. Initial Appointment Complete',
  },
  {
    value: '4. Agreement Signed',
    label: '4. Agreement Signed',
  },
  {
    value: '5. Ready for Submission',
    label: '5. Ready for Submission',
  },
  {
    value: '6. Submitted To Operations',
    label: '6. Submitted To Operations',
  },
  {
    value: '7. Closed Won',
    label: '7. Closed Won',
  },
  {
    value: '8. At-Risk Customer',
    label: '8. At-Risk Customer',
  },
  {
    value: '9. Cancelled Project',
    label: '9. Cancelled Project',
  },
  {
    value: '10. Installed PTO',
    label: '10. Installed PTO',
  },
  {
    value: '11. Closed Lost',
    label: '11. Closed Lost',
  },
];

const DEFAULT_LV_CONTROLS = {
  stage: 'default',
  beginCreatedDate: formatDateForInput(
    new Date(new Date().setDate(new Date().getDate() - 90)).toISOString(),
  ),
  endCreatedDate: formatDateForInput(
    new Date(new Date().setDate(new Date().getDate() + 1)).toISOString(),
  ),
  searchTerm: '',
  sortParam: '',
  sortDirection: 'DESC',
} as ListViewControls;

export { LEAD_STAGE_OPTIONS, OPPORTUNITY_STAGE_OPTIONS, DEFAULT_LV_CONTROLS };
export type { ListViewStageOption };
